import set from 'lodash/set';
import EnvVars from '../declarations/major/EnvVars';


class Client {
    static activity = true;

    static getBaseUrl() {
        if (this.activity) {
            return `${window.location.origin}/.proxy/api`;
        }
        return `${EnvVars.serverAddress}`;
    }

    static async request(url: string, data: RequestInit = {}): Promise<Response> {
        const newData = { ...data };
        set(newData, 'credentials', 'include');
        return await fetch(`${this.getBaseUrl()}${url}`, newData);
    }

    static SSERequest(url: string, callback: (data: string) => void): EventSource {
        const eventSource = new EventSource(`${this.getBaseUrl()}${url}`, { withCredentials: true });

        eventSource.onmessage = (e) => {
            callback(e.data as string);
        };

        return eventSource;
    }
}


export default Client;
